<template>
  <table>
    <caption>
      <span>{{ props.title }}</span>
    </caption>
    <thead>
      <tr>
        <th v-for="(item, index) in props.headers" :key="index">{{ item }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, rowid) in data" :key="rowid">
        <td v-for="(col, colid) in row" :key="colid">{{ col }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
const props = defineProps({ headers: Array, data: Array, title: String })
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
caption,
th {
  height: 2em;
  line-height: 2em;
}
caption {
  color: white;
  text-shadow:
    2px 2px 10px rgba(255, 255, 255, 0.3),
    -2px -2px 10px rgba(255, 255, 255, 0.3);
  font-size: 1.5em;
  font-weight: bold;
  letter-spacing: 3px;
}
th {
  background-color: rgba(5, 41, 88, 0.5);
  color: rgb(49, 192, 250);
  font-size: 1.2em;
}
td {
  height: 1.7em;
  line-height: 1.7em;
}
tr {
  border-bottom: 2px dashed rgb(6, 52, 100);
}
tr:last-child {
  border-bottom: initial;
}
</style>
